import { useContext } from "react";
import { GenerateInvoicePdfActionContext } from "./GenerateInvoicePdfActionContext";

function usePrepareGenerateInvoicePdf() {
  const { setShowModal, setInvoiceId } = useContext(GenerateInvoicePdfActionContext);
  return (invoiceId: string | number) => {
    setInvoiceId(invoiceId);
    setShowModal(true);
  };
}

export default usePrepareGenerateInvoicePdf;
